export default __webpack_public_path__ + "static/product4-f2d23521dd7ec2726751f32b6ae83603.jpg";